import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage/LandingPage';  
import LoginForm from './pages/LoginForm/LoginForm';
import SignupForm from './pages/SignupForm/SignupForm';
import Dashboard from './pages/Dashboard/Dashboard';
import PlayerUpdate from './pages/PlayerUpdate/PlayerUpdate';
import Recruits from './pages/Recruits/Recruits';
import SettingsPage from './pages/SettingsPage/SettingsPage';
import Calendar from './pages/Calendar/Calendar'
import ResetPassword from './pages/ResetPassword/ResetPassword';
import Layout from './Layout';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';



function App() {
  return (
    <Router>
      <Routes>
        {/* Define routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/signup" element= {<SignupForm />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/player/:token" element={<PlayerUpdate />} />

        {/* Sidebar loaded "globally" */}
        <Route element = {<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/recruits" element={<Recruits />} />
          <Route path="/profile" element={<SettingsPage />} />
          <Route path="/calendar" element={<Calendar />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;


